[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 5,
                "key": "bz4Ns"
            },
            {
                "x": 4,
                "y": 5,
                "key": "CNTmR"
            },
            {
                "x": 4,
                "y": 2,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 9,
                "y": 2,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 9,
                "y": 4,
                "key": "SbR3N"
            },
            {
                "x": 10,
                "y": 4,
                "key": "NYeCh"
            },
            {
                "x": 10,
                "y": 7,
                "key": "-l9Xq"
            },
            {
                "x": 5,
                "y": 7,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]